<template>
    <k-dialog @close="cancel">
     <div class="d-flex align-content-end" style="width: 600px; height: 400px">
      <div :style="{ marginBottom: '1rem' }">
        <label>
          Vorname<br />
          <k-input
            type="text"
            :name="'vorname'"
            v-model="personInEdit.vorname"
          ></k-input>
        </label>
      </div>
      <dialog-actions-bar>
        <button class="k-button" @click="cancel">Abbruch</button>
        <button class="k-button k-primary" @click="save">Sichern</button>
      </dialog-actions-bar>
  </div>
    </k-dialog>
</template>
<script>
import { Dialog, DialogActionsBar } from "@progress/kendo-vue-dialogs";
import { Input } from "@progress/kendo-vue-inputs";

export default {
  components: {
    "k-input": Input,
    "k-dialog": Dialog,
    "dialog-actions-bar": DialogActionsBar,
  },
  props: {
    dataItem: Object,
  },
  data: function () {
    return {
      personInEdit: {
        vorname: "",        
      },
    };
  },
  created: function () {
    if (this.$props.dataItem) {
      this.personInEdit = this.$props.dataItem;
    }
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    save() {
      this.$emit("save");
    },
  },
};
</script>
